import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import QrCodeSvg from 'react-qr-code';

// the QR code fills its container but never grows past this; in a narrower container it shrinks to fit
const MAX_QR_CODE_SIZE = 256;

interface Props {
  value: string;
  id?: string;
  sx?: SxProps<Theme>;
}

const QRCode: React.FC<Props> = ({ value, sx, id }) => (
  <Box
    id={id}
    sx={[
      {
        backgroundColor: (theme) => theme.palette.common.white,
        p: 1,
        lineHeight: 0,
        display: 'inline-block',
        maxWidth: '100%'
      },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
  >
    <QrCodeSvg
      value={value}
      size={MAX_QR_CODE_SIZE}
      style={{ width: '100%', height: 'auto', maxWidth: MAX_QR_CODE_SIZE }}
    />
  </Box>
);

export default QRCode;
